export default {
  translation: {
    account: {
      links: {
        logout: 'Logout',
        portal: 'Bidding Portal',
        profile: 'Profile',
      },
    },
    archive: {
      title: 'Archive',
      subtitle: 'online catalogues of past sales',
      search: {
        title: 'Suchen',
        label: 'Archive search',
      },
    },
    auctions: {
      button: {
        label: 'Go to auction',
      },
      empty: 'No public auctions found.',
      nonPlanned: 'There are no planned auctions.',
    },
    bidform: {
      address: '<h2 class="logo">RIPPON BOSWELL & CO. GmbH</h2>Friedrichstrasse 45<br />D - 65185 Wiesbaden<br />Germany<p>Phone: +49 611 334430<br /><strong>Fax: +49 611 3344326</strong></p>',
      auctionPassed: 'There is currently no auction for which you can place bids.',
      info: 'I wish to participate in the forthcoming auction on <strong>{{date}}</strong> with my written resp. telephone bid(s). Please bid on my behalf resp. phone me for the following lot(s) up to the hammer price(s) written below, to be executed as cheaply as is permitted by other bids or reserves. I agree to be bound to the Conditions of Sale applicable to this auction as stated in the printed catalogue and published on the Rippon Boswell homepage. I agree to pay a buyer\'s premium of <strong>{{provision}}%</strong> on the hammer price(s) and VAT at the current rate (<strong>{{vat}}%</strong>) on the premium.',
      title: 'Absentee Bid Form',
      success: 'Please print out the created PDF and send it signed either by post or fax to the above address.',
      date: 'Date',
      signature: 'Signature',
      pdf: {
        address: 'RIPPON BOSWELL & CO. GmbH\nFriedrichstrasse 45\nD - 65185 Wiesbaden\nGermany\n\nTel.: +49(0)611 - 33 44 30\nTelefax: +49(0)611 - 3 34 43 26',
        filename: 'Commission Bidding Form',
        info: 'Please bid on my behalf at the auction on {{date}}, for the following lot number (the following lot numbers) up to the amount specified (the amounts specified). All commissions must be executed at the lowest possible hammer prices and according to the Conditions of Sale printed in the catalogue to which I hereby expressiv agree by signing this form. The auctioneers will charge a buyer\'s premium of {{provision}} percent on the hammer price, plus German VAT of {{vat}} percent on the buyer\'s premium.',
        title: 'Commission Bidding Form',
      },
    },
    catalog: {
      back: {
        archive: 'Archive',
        results: 'Results',
      },
      condition: 'Condition',
      details: {
        open: 'View details',
        close: 'Close details',
      },
      emptyWishlist: 'You have not saved any lots to your wishlist.',
      exchangeRates: {
        title: 'Exchange rates',
        eur: '{{eur}} EUR',
        gbp: '{{gbp}} GBP',
        usd: '{{usd}} USD',
      },
      filter: {
        byBookmarks: 'Filter by wishlist',
        hide: 'Hide filter',
        reset: 'Reset filter',
        show: 'Show filter',
      },
      fullscreen: {
        close: 'Close fullscreen view',
        open: 'Open  fullscreen view',
      },
      fulltextsearch: 'Full-text search',
      literature: 'Literature',
      literatureShort: 'Lit.:',
      lotCount: '{{count}} Lots',
      lotCount_one: '{{count}} Lot',
      lotCountFiltered: '{{count}} of {{total}} Lots',
      lotsPerPage: 'Lots per page',
      noAuction: 'No Auction found',
      noLots: 'No lots found',
      origin: 'Origin',
      print: 'Print',
      published: 'Published',
      publishedShort: 'Publ.:',
      sortBy: 'Sort by',
      sortByLotNoAsc: 'Lot Number ascending',
      sortByLotNoDesc: 'Lot Number descending',
      sortByEstimateAsc: 'Estimate ascending',
      sortByEstimateDesc: 'Estimate descending',
      sortByResultAsc: 'Result ascending',
      sortByResultDesc: 'Result descending',
      sortByOriginAsc: 'Origin ascending',
      sortByOriginDesc: 'Origin descending',
      sortByWidthAsc: 'Width ascending',
      sortByWidthDesc: 'Width descending',
      sortByHeightAsc: 'Height ascending',
      sortByHeightDesc: 'Height descending',
      title: 'Online Catalogue {{number}}',
      view: {
        grid: 'Grid view',
        list: 'List view',
        table: 'Table view',
      },
    },
    catalogorder: {
      auctionCatalog: 'Auction Catalogue',
      catalogSubscription: 'Catalogue subscription starting with',
      currentCatalog: 'Current Catalogue',
      title: 'Order Catalogue',
      info: 'Please make sure to fill out the form completely. Otherwise we can not accept your order.',
      incVatAndPostageDe: '{{price}},- {{currency}} including VAT and postage Inland',
      incVatAndPostageEu: '{{price}},- {{currency}} including VAT and postage Europe',
      incVatAndPostageOverseas: '{{price}},- {{currency}} including VAT and postage overseas',
      order: 'Order:',
      paymentType: {
        label: 'Payment Method:',
        visa: 'VISA/Mastercard',
        wiretransfer: 'Wire Transfer',
      },
      send: 'Submit',
      success: 'Your catalog order was sent successfully.',
      error: {
        'captcha-failed': 'Captcha validation failed',
      },
    },
    contact: {
      title: 'Contact',
      info: 'Use this form to send us a message.<br />Your note will be fowarded to <strong>info@rippon-boswell-wiesbaden.de</strong>.',
      warning: 'Please make sure to fill out all fields marked with an asterisk <strong>*</strong>.',
      success: 'Your contact request was sent successfully.',
      error: {
        'captcha-failed': 'Captcha validation failed',
      },
    },
    content: {
      print: 'Print',
    },
    cookieConsent: {
      title: 'Cookie-Settings',
      info: 'This website uses cookies and similar functions to process end device information and personal data. The processing serves to integrate content, external services and elements of third parties as well as statistical analysis/measurement. Depending on the function, data is passed on to third parties. Your consent is always voluntary and can be refused or revoked at any time via the link "Cookie settings" at the bottom of the page.',
      button: {
        accept: 'Accept all',
        decline: 'Only essential',
        imprint: 'Imprint',
        imprintLink: '/about-us/imprint',
        moreDetails: 'More details',
        lessDetails: 'Less details',
        privacyPolicy: 'Privacy Policy',
        privacyPolicyLink: '/about-us/privacypolicy',
        save: 'Save',
        unblockFunctional: 'Allow Functional Cookies',
        unblockMarketing: 'Allow Marketing Cookies',
      },
      cookies: {
        i18next: {
          purpose: 'Saves the language selection.',
          validity: 'Persistent',
        },
        hideCookieConsent: {
          purpose: 'Saves across sessions whether the cookie settings should be displayed.',
          validity: 'Persistent',
        },
        acceptedCookieGroups: {
          purpose: 'Saves across sessions which cookie groups have been approved.',
          validity: 'Persistent',
        },
        hcaptcha: {
          purpose: 'Used on forms to ensure you are a real person and not a bot.',
          validity: 'Session',
          blocked: 'We use HCaptcha to prevent spam requests. In order to use the form, you must accept functional cookies.',
        },
        pkSess: {
          purpose: 'Used by Matomo to record current visitor access.',
          validity: '30 minutes',
        },
        pkId: {
          purpose: 'Used by Matomo to identify the visitor.',
          validity: '13 months',
        },
        googlemaps: {
          purpose: 'Google Maps map display',
          validity: 'Session',
          blocked: 'In order to use the interactive Google map, you must accept marketing cookies.'
        },
      },
      group: {
        essential: 'Essential Cookies',
        functional: 'Functional Cookies',
        statistics: 'Statistics Cookies',
        markerting: 'Marketing Cookies',
      },
      table: {
        name: 'Name',
        provider: 'Provider',
        purpose: 'Purpose',
        validity: 'Validity',
      },
    },
    dates: {
      title: 'Auction dates {{date, YYYY}}',
      info: 'We invite you to consign your carpets and textiles to our successful auctions as early as possible. For a first opinion please send us photos or digital images of the relevant objects, giving measurements and a brief condition report prior to a visit to Wiesbaden or shipment for appraisal. <p>We are also prepared to evaluate important objects or larger collections at your home.</p>',
      dateFormat: 'Do MMM YYYY',
      hour: 'at {{hour}}',
      hourFormat: 'h a',
      hourHome: 'at {{hour}} ({{zone}})',
      hourLocal: '{{hour}} local',
      longDateDual: '{{home}} {{zone}}, {{local}} local',
      longDateFormat: 'dddd, MMMM Do YYYY [at] h a',
    },
    error: {
      403: {
        description: 'You don\'t have permission to access this resource.',
        heading: 'Access denied',
      },
      404: {
        description: 'The requests object could not be found.',
        heading: 'Not found',
      },
      422: {
        description: 'Server rejected one or more parameters.',
        heading: 'Invalid argument',
      },
      429: {
        description: 'Rate limit exceeded.',
        heading: 'Too many requests',
      },
      500: {
        description: 'Please contact an administrator.',
        heading: 'Server error',
      },
      generic: 'Something went wrong!',
    },
    form: {
      address: 'Address',
      consent: {
        title: 'Consent to the processing of personal data:',
        label: 'I agree to the processing of my personal data and have read the privacy policy.',
        help: 'We use your personal data given here only for the purpose of answering your questions [request] and do not share your data with third parties. If no business relationship or business relationship results from this inquiry, your data will be deleted after fulfillment of the purpose. You can object to the processing and storage at any time by sending an e-mail to info@rippon-boswell-wiesbaden.de',
      },
      country: 'Country',
      email: 'E-Mail Address',
      error: {
        address: {
          required: 'Please enter your address.',
        },
        bid: {
          required: 'Please enter a maximum bid.',
          min: 'Please enter a maximum bid.',
        },
        captcha: {
          required: 'Please confirm the Captcha query.',
        },
        consent: {
          required: 'Please agree to the data processing so that we can process your request.',
        },
        country: {
          required: 'Please provide the state you are living in.',
        },
        email: {
          required: 'Please enter your e-mail address.',
          valid: 'Please enter a valid email address.',
          min: 'Please enter the minimum number of characters',
        },
        firstname: {
          required: 'Please enter your first name.',
        },
        lastname: {
          required: 'Please enter your last name.',
        },
        message: {
          required: 'Please enter your question or short message.',
        },
        mixed: {
          default: 'Please correct this field.',
          required: 'Please fill out this field.',
        },
        name: {
          required: 'Please enter your name.',
        },
        payment: {
          required: 'Please select the payment method.',
        },
        phone: {
          required: 'Please enter your telephone Number.',
        },
        street: {
          required: 'Please enter your street and house number.',
        },
        subscription: {
          required: 'Please choose a catalog subscription or the current edition of the online catalogue.',
        },
        token: {
          required: 'Please confirm the Captcha query.',
        },
        zip: {
          required: 'Please enter your zip code and place of residence.',
        },
      },
      fax: 'Fax',
      firstname: 'Firstname',
      lastname: 'Lastname',
      name: 'Name',
      passportReminder: 'Please send a copy of your ID.',
      phone: 'Phone',
      print: 'Print',
      salecode: 'Sale Code No.',
      send: 'Send',
      sender: 'Sender',
      street: 'Street',
      streetAndNo: 'Street And No.',
      message: 'My Question Or Short Message',
      zipAndCity: 'Postal Code And City',
    },
    front: {
      aftersale: 'Aftersale',
      catalog: 'Catalogue',
      results: 'Results',
    },
    general: {
      add: 'Add',
      address: 'Friedrichstraße 45,<br />D-65185 Wiesbaden,<br />Phone +49 (0)611 – 33 44 30<br />Email: info@rippon-boswell-wiesbaden.de<br />www.rippon-boswell-wiesbaden.de',
      all: 'All',
      auctionDate: 'on {{date}}',
      close: 'Close',
      dateFormat: '{{ date, DD.MM.YYYY }}',
      datetimeFormat: '{{ date, DD.MM.YYYY hh:mm a }}',
      days_one: 'day',
      days_other: 'days',
      filename: '{{date, YYYY-MM-DD}} {{name}}',
      filter: 'Filter',
      goToOverview: 'Go to overview',
      home: 'Home',
      hours_one: 'hour',
      hours_other: 'hours',
      letterDate: 'Wiesbaden, {{date, DD.MM.YYYY}}',
      loading: 'loading...',
      longDateFormat: '{{date, dddd, Do MMMM YYYY}}',
      menu: 'Menu',
      minutes_one: 'minute',
      minutes_other: 'minutes',
      more: 'more',
      page: 'Page',
      pageNotFound: 'The page you are looking for does not exist.',
      pageNotFoundTitle: '404',
      of: ' of ',
      scrollTop: 'To the top',
      seconds_one: 'second',
      seconds_other: 'seconds',
    },
    highlights: {
      title: 'Highlights',
      subtitle: 'Highlights of our auctions since autumn 2007',
    },
    language: 'Language',
    location: {
      title: 'Location',
      linkTitle: 'Larger Map View',
    },
    login: {
      button: 'Login',
      error: {
        popupBlocked: 'The login popup was blocked by your browser.',
        popupClosed: 'The login popup was closed.',
      },
      hint: 'Please log in to access the portal.',
      title: 'Login',
    },
    lots: {
      add_one: 'Add lot',
      add_other: 'Add lots',
      advancebid: {
        amount: 'Bid Amount in EUR',
        deleted: 'Your advance bid was deleted successfully.',
        disabled: 'This auction can no longer receive advance bids.',
        edit: 'Edit bid',
        edithint: 'You already have an advance bid for this lot. Please enter a new maximum bid to update your existing bid. You can delete your bid up to 24 hours prior the auction by clicking the delete button.',
        editphone: 'Edit phone bid',
        incrementWarningTitle: 'Please enter a value within the auction\'s increments.',
        limitWarning: 'Your advance bid of {{bid}} is below the starting price of {{limit}} and will not be considered for the auction.',
        limitWarningTitle: 'Advance bid to low',
        phone: 'Phone',
        phonebid: 'Register for telephone bidding',
        phonehint: 'To bid by phone, please enter your phone number here. We will call you in time for your lot during the auction.',
        remove: 'Remove bid',
        removephone: 'Remove phone bid',
        save: 'Leave a bid',
        success: 'Your advance bid was saved successfully.',
        title: 'Advance bid / phone bid',
        type: {
          phone: 'Phone bid',
          written: 'Written preliminary bid',
        },
        writtenhint: 'For a written preliminary bid, please enter your maximum bid in € here.',
      },
      aftersale: {
        amount: 'Bid Amount in EUR',
        button: 'Submit bid',
        error: 'Errors occured submitting your bid.',
        hint: 'Please enter your bid in EUR.',
        limit: 'Limit',
        limitIn: 'Limit in {{currency}}',
        submit: 'Submit Bid',
        success: 'Your bid was submitted successfully.',
        title: 'After Sale',
      },
      age: 'Age',
      bid: 'Highest bid in €',
      bidForLot: 'Bid on lot.',
      bookmark: {
        remove: 'Remove from wishlist',
        save: 'Add to wishlist',
      },
      description: 'Title Description',
      details: {
        hide: 'Hide details',
        show: 'Show details',
      },
      dimensions: 'Size',
      estimate: 'Estimate',
      estimateIn: 'Estimate in {{currency}}',
      filename: {
        archive: 'Online Catalogue A{{auction.number}}',
        highlights: 'Highlights',
        'online-catalog': 'Online Catalogue A{{auction.number}}',
        results: 'Results A{{auction.number}}',
      },
      filterByBookmarks: 'Filter by bookmarked',
      headCellLabel: {
        image: '',
        number: 'Lot No.',
        title: 'Title Description',
        age: 'Age',
        dimensions: 'Size',
        estimate: 'Estimate in EUR',
      },
      images: {
        alternate: 'Alternate lot views',
        next: 'Next image',
        previous: 'Previous image',
      },
      info: {
        hide: 'Hide informationen',
        show: 'Show informationen',
      },
      label: 'Lots',
      limit: 'Start price',
      limitIn: 'Start price in {{currency}}',
      navigate: {
        next: 'Further to lot {{number}}',
        previous: 'Back to lot {{number}}',
      },
      noBidsError_one: 'Please enter a highest bid for the selected lot.',
      noBidsError_other: 'Please enter highest bids for the selected lots.',
      noSelection: 'No lots selected',
      noSelectionError: 'Please select at least one lot.',
      number: 'Lot No.',
      origin: 'Origin',
      perPage: 'Lots per page:',
      removeBid: 'Remove bid',
      result: 'Result, including buyer’s premium',
      resultIn: 'Result in {{currency}}, including buyer’s premium',
      rowDisplay: '{{page}} of {{count}}',
      select: 'Select Lots',
      selectAll: 'Select all lots',
      selectWithCount_one: '{{count}} lot selected',
      selectWithCount_other: '{{count}} lots selected',
      sizeComparison: {
        hide: 'Hide size comparison',
        show: 'Show size comparison',
      },
      surcharge: 'Hammerprice',
      surchargeIn: 'Hammerprice in {{currency}}',
      title: 'Lot Title',
    },
    news: {
      title: 'Reports',
    },
    newsletter: {
      title: 'Current Newsletter',
    },
    portal: {
      acceptBid: 'Accept bid',
      adminAuctionNotInitialized: 'The auction is not yet initialized.',
      adminAuctionPending: 'The auction is not yet open.',
      adminView: 'Admin View',
      advanceBidFrom: 'Advance bid from {{name}}: {{ask}}',
      advanceBidFromDiffering: 'Advance bid from {{name}}: {{ask}} ({{amount}})',
      ask: 'Ask',
      auctionClosed: 'The auction is closed.',
      auctionNotInitialized: 'Please wait until the auction is set up.',
      auctionNumber: 'Auction {{number}}',
      auctionOpensIn: 'Auction opens in',
      auctionPaused: 'The auction is currently paused.',
      auctionPending: 'Please wait for the auctioneer to open this auction.',
      auctionStatus: {
        CLOSED: 'Closed',
        LIVE: 'Live',
        PAUSED: 'Paused',
        PENDING: 'Pending',
      },
      bid: 'Bid',
      bidderModalTitle: 'Lots won',
      boughtBy: 'Bought by {{name}}',
      callLot: 'Call lot',
      closeAuction: 'Close auction',
      closeLot: 'Close',
      currentBid: 'Current Bid',
      deleteBid: 'Delete Bid',
      estimate: 'Estimate',
      fairWarning: 'Warning, this lot is about to close!',
      hammerLot: 'Hammer',
      increments: 'Increments',
      isBuyer: 'You are the buyer.',
      isBuyerReserved: 'You have purchased the lot subject to reservation.',
      isHolder: 'Your bid is currently the highest.',
      isPotentialHolder: 'Your bid is currently the highest, but will have to be confirmed by the auctioneer.',
      lastCall: 'Last call',
      limit: 'Start price',
      liveBidFrom: 'Live bid by {{name}}: {{amount}}',
      lot: 'Lot',
      lotClosed: 'Lot closed',
      lotIsLive: 'Lot is live',
      lotIsSold: 'Lot sold',
      lotIsUnsold: 'Lot unsold',
      lotIsReserved: 'Lot u.v.',
      lotNumber: 'Lot No.',
      lotDescription: 'Lot Description',
      lotPending: 'Please wait for auctioneer to open bidding on this lot.',
      lotReset: 'Lot reset',
      lotResult: {
        SOLD: 'Sold',
        RESERVATION: 'Reserved',
        UNSOLD: 'Unsold',
      },
      lotSelect: 'Select lot',
      lotStatus: {
        CLOSED: 'Closed',
        LIVE: 'Waiting',
        ONE: 'Going once',
        PENDING: 'Pending',
        THREE: 'Fair warning',
        TWO: 'Going twice',
      },
      lotsWonCount: 'Won {{count}} lots',
      lotsWonCount_one: 'Won a lot',
      lotsWonCount_zero: 'No lots won yet',
      lotUnsold: 'Lot unsold',
      nextLot: 'Next Lot',
      noActiveLot: 'No active lot',
      noActiveLotHint: 'Please wait until the auctioneer opens the next lot.',
      noAlternateBids: 'No online or prepared bid available',
      noAuction: 'No auction found',
      noLots: 'No lots found',
      noNotices: 'No messages available.',
      noPendingBids: 'No pending bids',
      noSearchResults: 'No search results found',
      notice: 'Messagetext',
      notices: 'Messagetexts',
      openAuction: 'Open auction',
      openIncrementModal: 'Show more steps',
      openLot: 'Open',
      pendingBids: 'Pending bids',
      phoneBidFrom: 'Phone bid by {{name}}, No.: {{phone}}',
      phoneBidFromAmount: 'Phone bid by {{name}}, No.: {{phone}} (up to {{amount}})',
      placeBid: 'Place Bid',
      placeRoomBid: 'Place Room Bid',
      previousLot: 'Previous Lot',
      price: 'Price',
      protocol: {
        'advance-bid-accepted': 'Advance bid of {{value}} accepted',
        'advance-bid-invalidated': 'Advance bid invalidated',
        anonymousBid: 'Bid over {{value}}',
        bid: 'Bid by {{name}} over {{value}}',
        'bid-accepted': 'Bid of {{value}} accepted',
        'bid-invalidated': 'Bid invalidated',
        closed: 'Lot closed',
        date: '{{date, HH:mm:ss}}',
        empty: 'No protocol entries found.',
        increment: 'Increment set to {{value}}',
        'limit-override': 'Changed limit to {{value}}',
        one: 'Going once',
        opened: 'Lot opened',
        reset: 'Lot reset',
        revert: 'Bid retracted',
        'revert-invalidated': 'Retraction invalidated',
        three: 'Fair warning',
        two: 'Going twice',
      },
      reopenLot: 'Reopen',
      resumeAuction: 'Resume auction',
      room: 'Room',
      roomBid: 'Room bid',
      roomSale: 'Room sale',
      roomSaleReserved: 'Room sale (reserved)',
      search: 'Search',
      sendNotice: 'Send message',
      startPrice: 'Start Price',
      submit: 'Submit',
      submitBid: 'Submit Bid',
      submitLimit: 'Change limit',
      surcharge: 'Hammerprice',
      surchargeConditional: 'Hammerprice (conditional)',
      title: 'Title',
      unsold: 'Unsold',
      upcommingLots: 'Upcoming Lots',
      userView: 'User View',
    },
    profile: {
      advanceBids: 'Your advance bids',
      advanceBidsEmpty: 'You have not placed any advance bids.',
      field: {
        additionalAddress: 'Additional address',
        city: 'City',
        country: 'Country',
        email: 'Email',
        firstname: 'First name',
        lastname: 'Last name',
        salutation: 'Salutation',
        street: 'Street',
        title: 'Title',
        zip: 'Zip',
      },
      salutation: {
        c: 'Company',
        f: 'Mrs',
        m: 'Mr',
      },
      submit: 'Submit changes',
      submitError: 'Error while saving your data',
      submitSuccess: 'Saved',
      title: 'Profile',
      watchlist: 'Your watchlist',
      watchlistEmpty: 'Your watchlist is empty.',
      wonLots: 'Lots won in A{{auction.number}}',
      wonLotsEmpty: 'None',
    },
    results: {
      title: 'Results fo our auctions',
    },
    search: {
      title: 'Search results',
      subtitle: 'Searched for {{phrase}} in all auctions',
    },
    subscribe: {
      title: 'Newsletter subscription',
      consent: {
        title: 'Consent to the processing of personal data:',
        label: 'I consent to the processing of my personal data and have read the privacy policy.',
        help: 'We use your personal data provided here to keep you informed about our activities via e-mail. You can withdraw your decision at any time by clicking the unsubscribe link in the footer of any email you receive from us or by using the unsubscribe form on our website. We treat your data with care.',
      },
      error: {
        default: 'Errors occured signing up for our newsletter.',
        'subscriber-exists': 'The e-mail address is already in the mailing list.',
        'captcha-failed': 'Captcha validation failed',
      },
      send: 'Subscribe',
      success: 'You have successfully registered for our newsletter. Please confirm your email address using the link sent to you.',
    },
    unsubscribe: {
      error: {
        default: 'Errors occured unsubscibing from our newsletter.',
        'captcha-failed': 'Captcha validation failed',
      },
      title: 'Newsletter unsubscription',
      submit: 'Unsubscribe',
      success: 'You have successfully unsubscribed from our newsletter distribution list.',
    },
    zoomify: {
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      reset: 'Reset view',
      rotateLeft: 'Rotate left',
      rotateRight: 'Rotate right',
    },
  }
}
